import { BookingCategorySelector } from "PFApp/components/activity_form/field_factory/field_wrappers/booking_category_selector";
import { TemplateKey } from "PFApp/constants/templates";
import { useTemplate } from "PFApp/hooks";
import { useMultiActivityFormStore } from "PFApp/stores/activity_form/multi_roles_form";
import { RoleFormKey } from "PFApp/types/activity_form/activity_form_schema";
import { InputFocusProps } from "PFComponents/table/interactive/use_cell_input_focus";
import { Id, Subtemplate } from "PFCore/types";
import { useTranslation } from "react-i18next";

import { useFormActivityCreator } from "../../../../hooks/use_form_activity_creator";
import { TABULAR_FIELD_DROPDOWN_MIN_WIDTH } from "../../../../tabular_roles_form.utils";

type BookingCategoryCellProps = {
  value: Id | null;
  title: string;
  onChange: (value: Id | null) => void;
  subtemplate: Subtemplate | null;
  roleFormKey: RoleFormKey;
  portalRef: React.RefObject<HTMLDivElement | null>;
  disabled?: boolean;
  error?: string;
  inputFocusProps?: InputFocusProps;
};

export const BookingCategoryCell = ({
  value,
  title,
  onChange,
  subtemplate,
  roleFormKey,
  portalRef,
  disabled,
  error,
  inputFocusProps
}: BookingCategoryCellProps) => {
  const template = useTemplate(TemplateKey.Role)!;
  const { t } = useTranslation("activities", { keyPrefix: "engagementBlueprint" });
  const activityCreator = useFormActivityCreator(roleFormKey);
  const parentActivity = useMultiActivityFormStore((store) => store.parentActivity);

  return (
    <BookingCategorySelector
      activityCreator={activityCreator}
      onChange={onChange}
      bookingCategoryId={value}
      subtemplate={subtemplate}
      template={template}
      parentActivity={parentActivity}
      variant="table"
      portalRef={portalRef}
      dropdownWidth={TABULAR_FIELD_DROPDOWN_MIN_WIDTH}
      disabled={disabled}
      error={error}
      customInvalidValueMessage={t("bookingCategoryNotValid")}
      title={title}
      focusSearchInputOnOpen={false}
      {...inputFocusProps}
    />
  );
};
